module.exports = __WEBPACK_EXTERNAL_MODULE__angular_cdk_drag_drop__;